import React from 'react'
import { Link } from "react-router-dom"
import Navlogo from '../assets/odot.png'
import { useLocation } from 'react-router-dom';


export default function Navbar() {
    
    const location = useLocation();

    const { pathname } = location;

    const splitLocation = pathname.split("/");

    console.log(splitLocation)
    
    return (
        <div>
            <nav className="navbar navbar-expand-lg navbar-dark fixed-top" style={{ backgroundColor: "#0B265E", fontSize: "20px", fontWeight: "bold" }}>
                <a className="navbar-brand ms-3" href="https://www.owrb.ok.gov/" target="_blank"><img src={Navlogo} style={{ maxHeight: "40px" }} /></a>
                <button className="navbar-toggler collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#navbarCollapse"> <span className="navbar-toggler-icon"></span> </button>
                <div className="navbar-collapse collapse" id="navbarCollapse">
                    <ul className="navbar-nav">
                        <li className="nav-item"> <Link className="nav-link" id={(splitLocation[1] == "" ? "active" : "")} to="/">Home</Link></li>
                        <li className="nav-item"> <Link className="nav-link" id={(splitLocation[1] == "LowerCimarron" ? "active" : "")} to="/LowerCimarron">Lower Cimarron</Link></li>
                        <li className="nav-item"> <Link className="nav-link" id={(splitLocation[1] == "MuddyBoggy" ? "active" : "")} to="/MuddyBoggy">Muddy Boggy</Link></li>
                        <li className="nav-item"> <Link className="nav-link" id={(splitLocation[1] == "Kiamichi" ? "active" : "")} to="/Kiamichi">Kiamichi</Link></li>
                        <li className="nav-item"> <Link className="nav-link" id={(splitLocation[1] == "LowerCanadian" ? "active" : "")} to="/LowerCanadian">Lower Canadian</Link></li>
                        <li className="nav-item"> <Link className="nav-link" id={(splitLocation[1] == "RobertSKerr" ? "active" : "")} to="/RobertSKerr">Robert S. Kerr Reservoir</Link></li>
                        <li className="nav-item"> <Link className="nav-link" id={(splitLocation[1] == "ContactUs" ? "active" : "")} to="/ContactUs">Contact Us</Link></li>
                    </ul>
                </div>
            </nav>
        </div>
    )
}
